import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login1 from './pages/Login';
import Login2 from './pages/Login';
import Dashboard from './pages/Dashboard';
// import Users from './pages/Users';
import ManageCars from './pages/ManageCars';
import StopSale from './pages/StopSale';
import BoostPrice from './pages/BoostPrice';
import CarGroup from './pages/CarGroup';
import UserManagement from './pages/UserManagement';
import SeasonName from './pages/SeasonName';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import SeasonDuration from './pages/SeasonDuration';

import RentDurations from './pages/Rentdurations';
import CarPrice from './pages/CarPrice';
import ProtectedRoute from "./components/ProtectedRoute";
import TransferPrice from "./pages/TransferPrice";
import PromotionalPrice from './pages/PromotionalPrice';
import WeekendRate from './pages/WeekendRate';
import CabOwnerDetails from './pages/CabOwnerDetails';
import DriverDetails from './pages/DriverDetails';
import CabDetails from './pages/Cabdetails';
import ManageLeasingCar from './pages/ManageLeasingCar';
import LeasingPageContent from './pages/LeasingPageContent';
import ManageLeasingInq from './pages/ManageLeasing';
import CouponCode from './pages/CouponCode';
import InsuranceDetail from './pages/InsuranceDetail';
import OptionalExtraDetail from './pages/OptionalExtraDetail';
import ManageCity from './pages/ManageCity';
import ManageLocation from './pages/ManageLocation';
import ManageOnlineBooking from './pages/ManageOnlineBooking';
import ManageTransferBooking from './pages/ManageTransferBooking';
import InsuranceDaySlab from './pages/InsuranceDaySlab';
import ManageOptionalExtra from './pages/ManageOptionalExtra';
import ManageDelayCharge from './pages/ManageDelayCharge';
import ManageNightDelivery from './pages/ManageNightDelivery';
import ManagePageMaster from './pages/ManagePageMaster';
import ManageSetting from './pages/ManageSetting';
import ManageSection from './pages/ManageSection';
import Managebookingengine from './pages/Managebookingengine';
import ManageFaq from './pages/ManageFaq';
import ManageContract from './pages/ManageContract';
import ManageInquiry from './pages/ManageInquiry';
import ManageRequest from './pages/Managerequest';
import ManageBanner from './pages/ManageBanner';
import ManageAttractions from './pages/ManageAttractions';
import ManageTestimonial from './pages/ManageTestimonial';
import ManageGallery from './pages/ManageGallery';
import ManageContents from './pages/ManageContents';
import ManageSeo from './pages/ManageSeo';
import ChangePassword from './pages/ChangePassword';
import LandingPage from './landing/LandingPage';
import OurCars from './ourcars/OurCars';
import OurCars2 from './ourcars/OurCars2';
import ModifyReservation from './pages/frontend-pages/ModifyReservation';
import BookingStep2 from './booking/BookingStep2';
import BookingStep3 from './booking/BookingStep3';
import BookingStep4 from './booking/Bookingstep4';
import BookingConfirmation from './booking/BookingConfirmation';
import AboutUs from './pages/frontend-pages/AboutUs';
import ContactUs from './pages/frontend-pages/ContactUs';
import Gallery from "./pages/frontend-pages/Gallery";
import FAQ from "./pages/frontend-pages/FAQ";
import Transfer_landing from "./transferbooking/Transfer_landing";
import TransferStep2 from "./transferbooking/TransferStep2";
import TransferStep3 from "./transferbooking/TransferStep3";
import TransferStep4 from "./transferbooking/TransferStep4";
import TransferPayment from "./transferbooking/TransferPayment";
import DistancePage from "./pages/DistancePage";

function App() {
  return (
    
    <BrowserRouter>
      <Routes>
      <Route path="/distance" element={<DistancePage />} />
      <Route path="/home" element={<LandingPage />} />
      <Route path="/our-cars" element={<OurCars />} />
      <Route path="/our-cars2" element={<OurCars2 />} />
      <Route path="/modify-reservetion" element={<ModifyReservation />} />
      <Route path="/" element={<Navigate to="/home" />} />
      
        {/* Admin pages start */}
        <Route path="/admin" element={<Login2 />} />
        <Route path="/login" element={<Login1 />} />
        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        {/* <Route path="/users" element={<Users />} /> */}
        <Route path="/manage-cars"   element={<ProtectedRoute><ManageCars /></ProtectedRoute>} />
        <Route path="/stop-sale"   element={<ProtectedRoute><StopSale /></ProtectedRoute>} />
        <Route path="/boost-price"   element={<ProtectedRoute><BoostPrice /></ProtectedRoute>} />
        <Route path="/cargroup" element={<ProtectedRoute><CarGroup /></ProtectedRoute>} />
        <Route path="/user-management" element={<ProtectedRoute><UserManagement /></ProtectedRoute>} />
        <Route path="/season-name" element={<ProtectedRoute><SeasonName /></ProtectedRoute>} />
        <Route path="/season-duration" element={<ProtectedRoute><SeasonDuration /></ProtectedRoute>} />
        <Route path="/rent-durations" element={<ProtectedRoute><RentDurations /></ProtectedRoute>} />
        <Route path="/car-price" element={<ProtectedRoute><CarPrice /></ProtectedRoute>} />
        <Route path="/transfer-price" element={<ProtectedRoute><TransferPrice /></ProtectedRoute>} />
        <Route path="/promotional-price" element={<ProtectedRoute><PromotionalPrice /></ProtectedRoute>} />
        <Route path="/weekend-rate" element={<ProtectedRoute><WeekendRate /></ProtectedRoute>} />
        <Route path="/cab-owner-details" element={<ProtectedRoute><CabOwnerDetails /></ProtectedRoute>} />
        <Route path="/driver-details" element={<ProtectedRoute><DriverDetails /></ProtectedRoute>} />
        <Route path="/cab-details" element={<ProtectedRoute><CabDetails /></ProtectedRoute>} />
        <Route path="/leasing-cars" element={<ProtectedRoute><ManageLeasingCar /></ProtectedRoute>} />
        <Route path="/page-content" element={<ProtectedRoute><LeasingPageContent /></ProtectedRoute>} />
        <Route path="/coupon-code" element={<ProtectedRoute><CouponCode /></ProtectedRoute>} />
        <Route path="/insurance-detail" element={<ProtectedRoute><InsuranceDetail /></ProtectedRoute>} />
        <Route path="/optional-extra-detail" element={<ProtectedRoute><OptionalExtraDetail /></ProtectedRoute>} />
        <Route path="/manage-city" element={<ProtectedRoute><ManageCity /></ProtectedRoute>} />
        <Route path="/manage-location" element={<ProtectedRoute><ManageLocation /></ProtectedRoute>} />
        <Route path="/manage-bookings" element={<ProtectedRoute><ManageOnlineBooking /></ProtectedRoute>} />
        <Route path="/manage-transferbooking" element={<ProtectedRoute><ManageTransferBooking /></ProtectedRoute>} />
        <Route path="/insurance-day-slab" element={<ProtectedRoute><InsuranceDaySlab /></ProtectedRoute>} />
        <Route path="/manage-optionalextra" element={<ProtectedRoute><ManageOptionalExtra /></ProtectedRoute>} />
        <Route path="/manage-delaycharge" element={<ProtectedRoute><ManageDelayCharge /></ProtectedRoute>} />
        <Route path="/manage-nightdelivery" element={<ProtectedRoute><ManageNightDelivery /></ProtectedRoute>} />
        <Route path="/manage-pagemaster" element={<ProtectedRoute><ManagePageMaster /></ProtectedRoute>} />
        <Route path="/manage-setting" element={<ProtectedRoute><ManageSetting /></ProtectedRoute>} />
        <Route path="/manage-section" element={<ProtectedRoute><ManageSection /></ProtectedRoute>} />
        <Route path="/manage-booking-engine" element={<ProtectedRoute><Managebookingengine /></ProtectedRoute>} />
        <Route path="/manage-faqs" element={<ProtectedRoute><ManageFaq /></ProtectedRoute>} />
        <Route path="/manage-contracts" element={<ProtectedRoute><ManageContract /></ProtectedRoute>} />
        <Route path="/manag-inquiry" element={<ProtectedRoute><ManageInquiry /></ProtectedRoute>} />
        <Route path="/manage-request" element={<ProtectedRoute><ManageRequest /></ProtectedRoute>} />
        <Route path="/manage-banners" element={<ProtectedRoute><ManageBanner /></ProtectedRoute>} />
        <Route path="/manage-attraction" element={<ProtectedRoute><ManageAttractions /></ProtectedRoute>} />
        <Route path="/manage-testimonial" element={<ProtectedRoute><ManageTestimonial /></ProtectedRoute>} />
        <Route path="/manage-gallery" element={<ProtectedRoute><ManageGallery /></ProtectedRoute>} />
        <Route path="/manage-content" element={<ProtectedRoute><ManageContents /></ProtectedRoute>} />
        <Route path="/manage-seo" element={<ProtectedRoute><ManageSeo /></ProtectedRoute>} />
        <Route path="/manage-leasinginq" element={<ProtectedRoute><ManageLeasingInq /></ProtectedRoute>} />
        <Route path="/change-password" element={<ProtectedRoute><ChangePassword /></ProtectedRoute>} />
        {/* Admin pages end */}

        <Route path="/booking-step2" element={<BookingStep2 />} />
        <Route path="/booking-step3" element={<BookingStep3 />} />
        <Route path="/booking-step4" element={<BookingStep4 />} />
        <Route path="/confirmation/:id" element={<BookingConfirmation />} />
        <Route path="/about-us" element={<AboutUs />} />  
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/faqs" element={<FAQ />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/transfer" element={<Transfer_landing />} />
        <Route path="/transfer-step2" element={<TransferStep2 />} />
        <Route path="/transfer-step3" element={<TransferStep3 />} />
        <Route path="/transfer-step4" element={<TransferStep4 />} />
        <Route path="/transfer-payment" element={<TransferPayment />} />
        
      </Routes>
    </BrowserRouter>
  );
}

export default App;